<h1>{{ 'fs.res.publication.changeRequest.title' | hisUi}}</h1>
<div *ngIf="publication?.changeRequest">
    <his-dialog-header
        #dialogHeader
		[showCustomButton]="true"
		[showResetButton]="true"
		[customButtonLabel]="'fs.res.common.forwardValidation'"
		[customButtonClass]="'button_highlighted_dark_green'"
		[customButtonImage]="'ARROW_RIGHT_FAT'"
		[showSearchButton]="showSearchButton"
        [showSaveButton]="false"
		[showBackButton]="showBackButton"
		(customEvent)="saveChangeRequest()"
		(resetInputs)="reset()">
        <ng-container dataBox>
            <span><strong>{{publication.title}}</strong></span>
            | <span [innerHTML]="(isNewChangeRequest ? 'fs.res.publication.changeRequest.hint' : 'fs.res.publication.changeRequest.alreadyEdited') | hisUi"></span>
		</ng-container>
    </his-dialog-header>
    <div class="layoutBlock"> 
        <div class="columnHalf">
		    <p-panel [header]="'fs.res.publication.changeRequest.publicationDetails' | hisUi">
		        <res-publication-details-panel [publication]="publication"></res-publication-details-panel>
		    </p-panel>
	    </div>
	    <div class="columnHalf"> 
		    <res-dynamic-tab-container
		        *ngIf="publication.changeRequest"
		        [objectDynamicContent]="publication.changeRequest"
		        [reloadTrigger]="reloadTrigger"
		        [hisDynamicContent]="'fs.res.common.dynamicContent.tab.dynamicFields'"
		        [dynamicComponent]="publication.changeRequest._dynamicComponent"
		        [target]="'publication.changeRequest'"
		        [fullWidth]="true"
		        [showOwnInfoPanel]="false">
		    </res-dynamic-tab-container>
		    </div>
    </div>
</div>
